export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11114.eae3d702.jpg";